import { IonItem, IonLabel, IonToggle } from "@ionic/react";

import { translate } from "~utils";

type ToggleProps = {
  label: string;
  isSelected?: boolean;
  onToggleChange: (e: boolean) => void;
};

export function Toggle(props: ToggleProps) {
  const { label, isSelected = false, onToggleChange } = props;

  return (
    <IonItem className="ion-no-padding" css={{ width: "inherit" }} lines="full">
      <IonLabel>
        <span className="font-medium">{label}</span>
      </IonLabel>
      <IonToggle
        aria-checked={true}
        aria-label={
          isSelected
            ? `${label} ${translate("ARIA_LABEL_SELECTED")}`
            : `${label} ${translate("ARIA_LABEL_DESELECTED")}`
        }
        checked={isSelected}
        onIonChange={(e: CustomEvent) => {
          onToggleChange(e.detail.checked);
        }}
        slot="end"
      />
    </IonItem>
  );
}
